/*
  Bos arama sonucu: sorgudaki kelimelerden magazadaki gercek urunleri onerir.
  7 Agu 2026.

  Nerede calisir: hem /search sayfasinda hem de header arama cekmecesinde.
  Cekmece icerigi innerHTML ile basildigi icin satir ici <script> calismaz,
  bu yuzden mantik burada durur ve MutationObserver ile kendini kurar.

  Kural: snippet'te elle kurulmus koleksiyon eslesmesi varsa (data-curated="true")
  hicbir sey yapilmaz, kurasyon bozulmaz.
*/
(function () {
  if (window.__searchRelaxInstalled) return;
  window.__searchRelaxInstalled = true;

  /* Yalnizca dilbilgisi kelimeleri: tamamen atilir */
  var STOP = 'a an and or the for with of in on to my your our by from at is are as'.split(' ');
  /* Magazada ayirt edici olmayan kelimeler: en sona birakilir */
  var GENERIC = ('set sets kit kits pack packs bundle duo trio combo piece pieces pcs ' +
    'small large medium mini big new baby babies toddler toddlers kid kids child children ' +
    'infant infants newborn size sizes color colors colour style item items product products ' +
    'best top buy online cheap free shipping').split(' ');
  var FIELDS = encodeURIComponent('title,product_type,variants.title,vendor,tag');

  function has(list, t) { return list.indexOf(t) !== -1; }

  function candidates(raw) {
    var seen = {}, specific = [], generic = [];
    raw.toLowerCase().replace(/[^a-z0-9]+/g, ' ').split(' ').forEach(function (t) {
      if (t.length < 3 || seen[t] || has(STOP, t)) return;
      seen[t] = 1;
      (has(GENERIC, t) ? generic : specific).push(t);
    });
    var byLen = function (a, b) { return b.length - a.length; };
    var ranked = specific.sort(byLen).concat(generic.sort(byLen));
    if (!ranked.length) return [];
    /* Once en ayirt edici kelimelerin birlesimi, sonra tek tek gevseterek */
    var out = [], i;
    for (i = Math.min(ranked.length, 3); i >= 1; i--) out.push(ranked.slice(0, i).join(' '));
    for (i = 1; i < Math.min(ranked.length, 3); i++) out.push(ranked[i]);
    return out.filter(function (c, ix) { return c && out.indexOf(c) === ix; }).slice(0, 5);
  }

  /* Shopify onerisi bulanik eslesir ("momi" -> "MOMIJI US LLC").
     Kelime BASI eslesmesi sartini biz koyuyoruz. */
  function hits(p, tok, titleOnly) {
    var hay = (p.title || '') + ' ' + (p.type || '');
    if (!titleOnly) hay += ' ' + (p.vendor || '') + ' ' + ((p.tags || []).join(' '));
    return new RegExp('(^|[^a-z0-9])' + tok.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).test(hay.toLowerCase());
  }

  function relevant(term, list) {
    var toks = term.split(' ');
    return list.filter(function (p) {
      return toks.every(function (t) { return hits(p, t, false); });
    }).sort(function (a, b) {
      var score = function (p) {
        return toks.filter(function (t) { return hits(p, t, true); }).length + (p.available ? 0.5 : 0);
      };
      return score(b) - score(a);
    });
  }

  function money(fmt, v) {
    var n = parseFloat(v);
    if (isNaN(n)) return '';
    if (!fmt) return '$' + n.toFixed(2);
    return fmt.replace(/\{\{\s*amount_no_decimals[^}]*\}\}/g, String(Math.round(n)))
              .replace(/\{\{\s*amount[^}]*\}\}/g, n.toFixed(2));
  }

  function card(p, fmt) {
    var a = document.createElement('a');
    a.href = p.url;
    a.style.cssText = 'text-decoration:none;color:inherit;display:block';
    var src = (p.featured_image && p.featured_image.url) || p.image;
    if (src) {
      var img = document.createElement('img');
      img.src = src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=360';
      img.alt = p.title || '';
      img.loading = 'lazy';
      img.width = 360;
      img.height = 360;
      img.style.cssText = 'width:100%;height:auto;border-radius:10px;aspect-ratio:1;object-fit:cover';
      a.appendChild(img);
    }
    var t = document.createElement('div');
    t.style.cssText = 'font-size:.85em;margin-top:7px;line-height:1.35';
    t.textContent = (p.title || '').length > 60 ? p.title.slice(0, 57) + '...' : (p.title || '');
    a.appendChild(t);
    var pr = document.createElement('div');
    pr.style.cssText = 'font-size:.85em;font-weight:700;margin-top:2px';
    pr.textContent = money(fmt, p.price);
    a.appendChild(pr);
    return a;
  }

  function render(root, term, products) {
    var grid = root.querySelector('[data-suggest-grid]');
    var title = root.querySelector('[data-suggest-title]');
    var link = root.querySelector('[data-suggest-link]');
    if (!grid) return;
    var max = parseInt(root.getAttribute('data-limit'), 10) || 8;
    var fmt = root.getAttribute('data-money-format');
    grid.textContent = '';
    products.slice(0, max).forEach(function (p) { grid.appendChild(card(p, fmt)); });
    if (title) {
      title.textContent = 'We could not find that exact item, but here is what we carry for "' + term + '"';
    }
    if (link) {
      link.textContent = 'See all results for "' + term + '" →';
      link.href = '/search?q=' + encodeURIComponent(term) + '&type=product';
    }
  }

  function reveal(root) { root.removeAttribute('data-pending'); }

  function lookup(term) {
    return fetch('/search/suggest.json?q=' + encodeURIComponent(term) +
      '&resources%5Btype%5D=product&resources%5Blimit%5D=10&resources%5Boptions%5D%5Bfields%5D=' + FIELDS,
      { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var list = (d && d.resources && d.resources.results && d.resources.results.products) || [];
        return relevant(term, list);
      })
      .catch(function () { return []; });
  }

  function run(root) {
    if (!root || root.dataset.relaxed) return;
    root.dataset.relaxed = '1';
    if (root.getAttribute('data-curated') === 'true') { reveal(root); return; }
    var raw = root.getAttribute('data-terms') || '';
    var cands = candidates(raw);
    if (!cands.length) { reveal(root); return; }

    /* Adaylari paralel sor: tek tur, blok bir an bos kalmasin */
    Promise.all(cands.map(lookup)).then(function (all) {
      var pick = null, i;
      for (i = 0; i < all.length; i++) {
        if (all[i].length >= 2) { pick = { term: cands[i], list: all[i] }; break; }
      }
      if (!pick) {
        for (i = 0; i < all.length; i++) {
          if (all[i].length) { pick = { term: cands[i], list: all[i] }; break; }
        }
      }
      if (pick) render(root, pick.term, pick.list);
      reveal(root);
    }).catch(function () { reveal(root); });
  }

  function scan(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.matches && node.matches('[data-search-suggest]')) run(node);
    var found = node.querySelectorAll ? node.querySelectorAll('[data-search-suggest]') : [];
    for (var i = 0; i < found.length; i++) run(found[i]);
  }

  function start() {
    scan(document.body);
    /* Arama cekmecesi sonuclari innerHTML ile sonradan basiliyor */
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        for (var j = 0; j < muts[i].addedNodes.length; j++) scan(muts[i].addedNodes[j]);
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
